/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext, useEffect, Component  } from "react";
import AuthContext from "../../context/Auth/AuthContext";
import SidebarContext from "../../context/Sidebar/SidebarContext";
import { Link } from "react-router-dom";
import NotificacionesContext from "../../context/Notificaciones/NotificacionesContext";
import sinWifi from '../../assets/images/sinwifi.jpg'
import conWifi from '../../assets/images/conwifi.jpg'
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {Row, Col, Card, CardBody, Spinner, Alert} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import useWindowDimensions from "../../hooks/dimensionsHook"
import UsuariosContext from "../../context/Usuarios/UsuariosContext";
import Switch from "@material-ui/core/Switch";
import { colors } from "@material-ui/core";

export default function Nav({ props }) {
  const [isOpen, setIsOpen] = useState(false);

  // ACCESO A ESTADO GLOBAL - SideBar
  const ctxSidebar = useContext(SidebarContext);
  const { toggleSidebar } = ctxSidebar;

  //ACCESO AL ESTADO GLOBAL - AUTENCIACION
  const ctxAuth = useContext(AuthContext);
  const { cerrarSesion, usuario } = ctxAuth;

  const ImpedirCierre = usuario? (usuario.reiniciarPassword? true:false):false;

  const notfContext = useContext(NotificacionesContext);
  const { numeroDeNotificaciones,WifiActivo } = notfContext;
 
  const handleChange = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    toggleSidebar();
  };

  const cerrarSesionUsuario = () => {
    cerrarSesion();
    window.location.href = "/login";
  };

    //ACCESO AL ESTADO GLOBAL - Estatus Vale
    const ctxUsuarios = useContext(UsuariosContext);
    const {
      usuarios,
      listarUsuarios,
      usuarioEditar,
      setUsuarioEditar,
      uploadEditarUsario,
      nuevoUsuario,
      setNuevoUsuario,
      uploadNuevoUsuario,
      solicitarReinicioPassword,
    } = ctxUsuarios;

  const [UISweetAlert, setUISweetAlert] = useState({
    confirm_editar_usuario: false,
    confirm_nuevo_usuario: false,
    editar_usuario: false,
    refresh_editar_usuario: false,
    success_dlg: false,
    reload_page: false,
    error_dlg: false,
    dynamic_title: "",
    dynamic_description: "",
  });   
    
  const [UsuariosFiltrados, setUsuariosFiltrados] = useState([]);
  const [procesoIniciado, setProcesoIniciado] = useState(false);
  const [entrada, setEntrada] = useState(true);
  const [cargaPrimaria, setCargaPrimaria] = useState(true);
  const [mostrarAlerta, setMostraralerta] = useState(false);
  const [clave, setClave] = useState('');
  const [clave2, setClave2] = useState('');
  const [clave3, setClave3] = useState('');
  

  const delay = async (ms) => {
    return new Promise((resolve) => 
        setTimeout(resolve, ms));
  };   
 
  const fetchUsuarios = async () => {
    if(!procesoIniciado && usuario && entrada){
      setProcesoIniciado(true)    
      const lista = await listarUsuarios();
      await delay(2000);

      setUsuariosFiltrados(
        lista.filter((usuariosp) => {
          if (usuariosp.idCatUsuario === usuario.idCatUsuario ) 
          { 
            if(ImpedirCierre){
              setUsuarioEditar(usuariosp);
              setMostraralerta(true);
            }
            return true;
          }
        })
      )
    }
  };

  const RecargaUsuarios = async () => {
      const lista = await listarUsuarios();
      await delay(2000);

      setUsuariosFiltrados(
        lista.filter((usuariosp) => {
          if (usuariosp.idCatUsuario === usuario.idCatUsuario ) 
          { 
            return true;
          }
        })
      )
  };

  const editarUsuario = () => {
    if(UsuariosFiltrados.length>0) 
    {
      UsuariosFiltrados.filter((usuariosp) => 
      { 
            if (usuariosp.idCatUsuario === usuario.idCatUsuario ) 
            {
              setUsuarioEditar(usuariosp);
            }
      })
      usuarioEditar.password = null
      setMostraralerta(true);
    }
  };

  const {width} = useWindowDimensions();
  const [loading, setLoading] = useState(false);

  const uploadUsuarioEditar = async () => {
    let readyToSend = true;
    if (!usuarioEditar.nombre) {
      setUISweetAlert({
        ...UISweetAlert,
        error_dlg: true,
        dynamic_title: "Fallo",
        dynamic_description: "Por favor, llene el campo nombre",
      });
      return;
    }

    if (!usuarioEditar.usuario) {
      setUISweetAlert({ 
        ...UISweetAlert,
        error_dlg: true,
        dynamic_title: "Fallo",
        dynamic_description: "Por favor, llene el campo usuario",
      });
      return;
    }

    const validateEmail = async (usr) => {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(usr.correo);
    };

    if (!usuarioEditar.correo) {
      setUISweetAlert({
        ...UISweetAlert,
        error_dlg: true,
        dynamic_title: "Fallo",
        dynamic_description: "Por favor, llene el campo correo",
      });
      return;
    } else 
    {
      const validEmail = await validateEmail(usuarioEditar);
      if (!validEmail) {
        readyToSend = validEmail;
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "Por favor, introduzca un correo válido",
        });
        return;
      }  
    }

    if(usuarioEditar.password!=null && usuarioEditar.password!='')
    {
      usuarioEditar.reiniciarPassword = true;

      if (!usuarioEditar.nuevoPassword) {
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "Inserte la nueva contraseña",
        });
        return;
      }
  
      if (usuarioEditar.password != null && usuarioEditar.nuevoPassword != usuarioEditar.confirmPassword) {
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "Las contraseñas nos son iguales",
        });
        return;
      }
  
      if (usuarioEditar.password == usuarioEditar.nuevoPassword) {
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "La nueva contraseña no puede ser la misma que la anterior",
        });
        return;
      }
  
      if (usuarioEditar.nuevoPassword.length < 8) {
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "La nueva contraseña debe tener al menos 8 caracteres",
        });
        return;
      } 
       const lower =  new RegExp('(?=.*[a-z])')
       const upper =  new RegExp ('(?=.*[A-Z])')
       const number =  new RegExp ('(?=.*[0-9])')
       const special =  new RegExp ('(?=.*[!@#\$%\^&\*])')
  
       if (!lower.test(usuarioEditar.nuevoPassword)){
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "La nueva contraseña debe tener letras minúsculas",
        });
        return;
      }
  
      if (!upper.test(usuarioEditar.nuevoPassword)){
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "La nueva contraseña debe tener al menos 1 letra mayúscula",
        });
        return;
      }
  
      if (!number.test(usuarioEditar.nuevoPassword)){
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "La nueva contraseña debe tener al menos 1 número",
        });
        return;
      }
  
      if (!special.test(usuarioEditar.nuevoPassword)){
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "La nueva contraseña debe tener al menos 1 caracter especial ! @ # $ % & *",
        });
        return;
      }
    }

    usuarioEditar.catRoles.map((catRolesUsr) => {
      if (catRolesUsr.idCatRol == "" && readyToSend) {
        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true,
          dynamic_title: "Fallo",
          dynamic_description: "Por favor, llene el nuevo rol",
        }); 
        readyToSend = false;
      }
    });

    if (readyToSend) 
    {
      setLoading(true);
      const res = await uploadEditarUsario();

      if (res.data.error) {
        setLoading(false);

        setUISweetAlert({
          ...UISweetAlert,
          error_dlg: true, 
          dynamic_title: "Fallo",
          dynamic_description: res.data.message,
        });
      } else if (res) {
        setLoading(false);
        setEntrada(false);
        setUISweetAlert({
          ...UISweetAlert,
          success_dlg: true,
          dynamic_title: "Exito",
          confirm_editar_usuario: false,
          dynamic_description: "Se registraron los cambios",
        });
        setMostraralerta(false);
        setClave("");
        setClave2("");
        setClave3("");
        RecargaUsuarios();
      } 
    }
  };

  const changeUsarioEditarConfig = async (e) => 
  {
    let value = e.target.value;

      if(!cargaPrimaria){ 
        usuarioEditar.password = ""
        usuarioEditar.nuevoPassword = ""
        usuarioEditar.confirmPassword = ""
        setCargaPrimaria(true)
      }
      if (e.target.name == "password")  
      {
        if(value.length<=0){
          value =''
          setClave('')
          usuarioEditar.password = ''
        }else{
          if(!usuarioEditar.password){
            usuarioEditar.password = ''
          }
          let cadenag = ""; 
          setClave('')
          for(let k = 0; k < value.length-1; k++){
            cadenag += '*'
          }  

          if(value.length < clave.length)
          {
            let temp = usuarioEditar.password
            let cadena = ""; 
            for(let k = 0; k < value.length; k++){
              cadena += temp[k];
            }  
            let comodin = cadenag + temp[temp.length-2]
            setClave(comodin)
            usuarioEditar.password = cadena;
          }else
          {
            let comodin = cadenag + value[value.length-1]
            setClave(comodin)
            usuarioEditar.password += value[value.length-1]
          }
        }
      }else if (e.target.name == "nuevoPassword") 
      {
        if(value.length<=0){
          value =''
          setClave2('')
          usuarioEditar.nuevoPassword = ''
        }else{
          if(!usuarioEditar.nuevoPassword){
            usuarioEditar.nuevoPassword = ''
          }
          let cadenag = ""; 
          setClave2('')
          for(let k = 0; k < value.length-1; k++){
            cadenag += '*'
          }  

          if(value.length < clave2.length)
          {
            let temp = usuarioEditar.nuevoPassword
            let cadena = ""; 
            for(let k = 0; k < value.length; k++){
              cadena += temp[k];
            }  
            let comodin = cadenag + temp[temp.length-2]
            setClave2(comodin)
            usuarioEditar.nuevoPassword = cadena;
          }else
          {
            let comodin = cadenag + value[value.length-1]
            setClave2(comodin)
            usuarioEditar.nuevoPassword += value[value.length-1]
          }
        }
      }else if (e.target.name == "confirmPassword") 
      {
        if(value.length<=0){
          value =''
          setClave3('')
          usuarioEditar.confirmPassword = ''
        }else{
          if(!usuarioEditar.confirmPassword){
            usuarioEditar.confirmPassword = ''
          }
          let cadenag = ""; 
          setClave3('')
          for(let k = 0; k < value.length-1; k++){
            cadenag += '*'
          }  

          if(value.length < clave3.length)
          {
            let temp = usuarioEditar.confirmPassword
            let cadena = ""; 
            for(let k = 0; k < value.length; k++){
              cadena += temp[k];
            }  
            let comodin = cadenag + temp[temp.length-2]
            setClave3(comodin)
            usuarioEditar.confirmPassword = cadena;
          }else
          {
            let comodin = cadenag + value[value.length-1]
            setClave3(comodin)
            usuarioEditar.confirmPassword += value[value.length-1]
          }
        }
      }else{
        setUsuarioEditar({
          ...usuarioEditar,
          [e.target.name]: value,
        });
      }
  }
  useEffect(() => {
     fetchUsuarios();
     delay(3000)
  }, [numeroDeNotificaciones,WifiActivo,usuario]);
  return( 
    <div className="relative z-9999 flex-shrink-0 flex bg-white border-b border-gray-200 lg:border-none nav-bar">
      <Card className="mt-4">
        <button
          onClick={(e) => handleToggleSidebar(e)}
          className="px-4 border-r border-gray-200 text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500">
          <span className="sr-only">Open sidebar</span>
          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" />
          </svg>
        </button>
      </Card>
      <div className="flex-1 px-8 flex justify-between sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8">
        <div className="flex-1 flex">
          {false ? (
            <form className="w-full flex md:ml-0" action="#" method="GET">
              <label htmlFor="search_field" className="sr-only">
                Search
              </label>
              <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none" aria-hidden="true">
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <input
                  id="search_field"
                  name="search_field"
                  className="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:border-transparent sm:text-sm"
                  placeholder="Buscar..."
                  type="search"
                />
              </div>
            </form>
          ) : null}

          {mostrarAlerta ? 
          (
            <SweetAlert
              title={"Editar Usuario"}
              showCancel = {entrada?!ImpedirCierre :true}
              showConfirm={true}
              confirmBtnText="Confirmar"
              confirmBtnBsStyle="success"
              cancelBtnText="Cancelar"
              cancelBtnBsStyle="danger"
              closeOnClickOutside={false}
              style={{
                width: width && width < 851 ? "100%" : "80%",  position: "absolute", zIndex: 2000,
              }}
              onConfirm={() => {
                uploadUsuarioEditar();
              }}
              onCancel={() => {
                setMostraralerta(false);
                setClave("");
                setClave2("");
                setClave3("");
                setCargaPrimaria(false)
              }}>
              <div >
                Para que se vean reflejados los cambios, se debe de confirmar.
              </div>
              <div>
                <Row className="form-group">
                  <label className="col-sm-4 col-form-label">Nombre</label>
                  <Col sm={7}>
                    <input
                      type="text"
                      className="form-control-disabled"
                      name="nombre"
                      disabled={true}
                      value={usuarioEditar.nombre}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Usuario</label>
                  <Col sm={7}>
                    <input
                      type="text"
                      className="form-control-disabled"
                      name="usuario"
                      disabled={true}
                      value={usuarioEditar.usuario}
                    />
                  </Col>
                </Row>
                <Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Correo</label>
                  <Col sm={7}>
                    <input
                      type="text"
                      className="form-control"
                      name="correo"
                      onChange={changeUsarioEditarConfig}
                      //value={"Password: " + usuarioEditar.password + "    Nuevo: " + usuarioEditar.nuevoPassword + "  confrimacion:" + usuarioEditar.confirmPassword}
                      value ={usuarioEditar.correo}
                    />
                  </Col>
                </Row>

                <Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Teléfono</label>
                  <Col sm={7}>
                    <input
                      type="text"
                      className="form-control"
                      name="telefonoFijo"
                      onChange={changeUsarioEditarConfig}
                      //value={"Password: " + usuarioEditar.password + "    Nuevo: " + usuarioEditar.nuevoPassword + "  confrimacion:" + usuarioEditar.confirmPassword}
                      value ={usuarioEditar.telefonoFijo}
                    />
                  </Col>
                </Row>

                <Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Celular</label>
                  <Col sm={7}>
                    <input
                      type="text"
                      className="form-control"
                      name="telefonoCelular"
                      onChange={changeUsarioEditarConfig}
                      //value={"Password: " + usuarioEditar.password + "    Nuevo: " + usuarioEditar.nuevoPassword + "  confrimacion:" + usuarioEditar.confirmPassword}
                      value ={usuarioEditar.telefonoCelular}
                    />
                  </Col>
                </Row>                                
                {/*<Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Contraseña actual</label>
                  <Col sm={7}>
                    <input 
                      placeholder="Inserte su contraseña actual"
                      type= {'password'}
                      className="form-control"
                      hidden = {false}                      
                      onChange = {ev => setClave(ev.target.value)}
                      //onChange={changeUsarioEditarConfig}
                    />
                  </Col>
                </Row>
            */}
                <Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Contraseña actual</label>
                  <Col sm={7}>
                    <input 
                      placeholder={ImpedirCierre? "Inserte su contraseña actual" : "Inserte su contraseña actual o deje en blanco para conservar la misma"}
                      //type= "password"
                      className="form-control"
                      name="password" 
                      onChange={changeUsarioEditarConfig}
                      value={clave}
                    />
                  </Col>
                </Row>                
                <Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Nueva Contraseña</label>
                  <Col sm={7}>
                    <input
                      placeholder="Inserte su nueva contraseña"
                      //type= "password"
                      className="form-control"
                      name="nuevoPassword"
                      onChange={changeUsarioEditarConfig}
                      value={clave2}
                    />
                  </Col>
                  <Col sm={4}>
                  </Col>    
                  <Col sm={6}>
                      <label >La nueva contraseña debe tener 8 caracteres mínimo, una letra mayúscula, un número y un carácter especial.</label>
                  </Col>                                                  
                </Row>
                <Row className="form-group mt-2">
                  <label className="col-sm-4 col-form-label">Confirmar Nueva Contraseña</label>
                  <Col sm={7}>
                    <input
                      placeholder="Confirme la nueva contraseña"
                      //type="password"
                      className="form-control"
                      name="confirmPassword"
                      onChange={changeUsarioEditarConfig}
                      value={clave3}
                    />
                  </Col>                          
                </Row>
              </div>
            </SweetAlert>
          ) : null}       

          {UISweetAlert.success_dlg ? (
            <SweetAlert
              success
              title={UISweetAlert.dynamic_title}
              onConfirm={() => {
                if (UISweetAlert.reload_page) {
                  window.location.reload();
                }
                setUISweetAlert({
                  ...UISweetAlert,
                  success_dlg: false,
                  reload_page: false,
                });
              }}>
              {UISweetAlert.dynamic_description}
            </SweetAlert>
          ) : null}

          {UISweetAlert.error_dlg ? (
            <SweetAlert
              error
              title={UISweetAlert.dynamic_title}
              onConfirm={() => {
                setUISweetAlert({
                  ...UISweetAlert,
                  error_dlg: false,
                });
              }}>
              {UISweetAlert.dynamic_description}
            </SweetAlert>
          ) : null}         
        </div>

        <div className="ml-4 flex items-center md:ml-6">
          <div className="ml-4 flex items-center md:ml-6">
            <Link to="/notificaciones">
              <button className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                {numeroDeNotificaciones > 0 ? (
                  <span className="badge badge-danger badge-pill">{numeroDeNotificaciones}</span>
                ) : null}
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </button>
            </Link>
          </div>

          <div className="flex-shrink-0 relative ml-4">
            <div className="ml-3 relative">
              <div>
                {/* onBlur={cerrarOpciones} */}
                <button
                  type="button"
                  onClick={(e) => handleChange(e)}
                  className="flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                  id="user-menu"
                  aria-expanded="false"
                  aria-haspopup="true">
                  {/* <img
                    className="h-8 w-8 rounded-full"
                    src="https://www.clipartmax.com/png/middle/40-400884_social-media-avatar-photography-digital-media-clip-social-media-avatar-photography-digital.png"
                    alt=""
                  /> */}
                  {/* {usuario ? (
                    <Image
                      className="rounded-full"
                      width={50}
                      height={50}
                      // src={usuario.inputStream && imagen.inputStream ? imagen.inputStream : "error"}
                      src={
                        usuario && usuario.mimeType && usuario.inputStream
                          ? `data:${usuario.mimeType};base64,` + usuario.inputStream
                          : "error"
                      }
                      fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                    />
                  ) : null} */}
                  {/* <span className="text-gray-700 mt-1.5 text-sm font-medium lg:block">{usuario ? usuario.nombre : ""}</span> */}

                  <span className="ml-2 text-gray-700 mt-1.5 text-sm font-medium lg:block">
                    {usuario ? usuario.nombre : "Iniciar Sesión"}
                  </span>
                  <svg
                    className="hidden flex-shrink-0 ml-1 h-5 w-5 text-gray-400 mt-1.5 lg:block"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div> 
              {isOpen ? (
                <div
                  onBlur={() => {
                    setIsOpen(false);
                  }}>
                  {/* {usuario ? (
                    <a onClick={redirectPerfil} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                      {"Perfil"}  
                    </a>
                  ) : null} */}
                    
                  <a onClick={editarUsuario} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    <i className="mdi mdi-account-lock-outline font-size-17 align-middle mr-1"></i>
                    {usuario ? "Mis datos" : null}
                  </a>        

                  <a onClick={cerrarSesionUsuario} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    <i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>
                    {usuario ? "Cerrar Sesión" : "Iniciar Sesión"}
                  </a>
                </div>
              ) : null}
            </div>
          </div>  

          <div className="flex-shrink-0 relative ml-4">
            <img className="logowifi"
              src ={WifiActivo}/>  
          </div>   
         
        </div>
      </div>
    </div>
  );
} 